import { render, staticRenderFns } from "./showRevwMail.vue?vue&type=template&id=6e72a74d"
import script from "./showRevwMail.vue?vue&type=script&lang=js"
export * from "./showRevwMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports